import { VoiceCommand } from "../../interfaces/appContext/appContext.interface";

export const defaultVoiceCommand: VoiceCommand = {
    command: '',
    confidence: 0.0,
    isMatched: false,
    playerAction: ''
};